<template>
  <div class="state-info">
    <div class="title"><h3>状态</h3></div>
    <el-form label-width="90px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="审核状态：">{{insideData.auditState|auditState}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发布状态：">
            <el-button type="primary" plain @click="goRelease()">详情</el-button>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item label="上线状态：" >
            {{insideData.deleteFlag==1?'已下线':'已上线'}}
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'StateInfo',
  props: ['insideData'],
  methods: {
    // 查看发布状态
    goRelease () {
      this.$emit('goRelease')
    }
  }
}
</script>

<style lang="less" scoped>
  .title {
    border-bottom: 1px solid rgba(0, 0, 0,.1);
    margin-bottom: 15px;
    font-weight: 400;
    color: #33343B;
  }
</style>
